"use client";

import { useTheme } from "next-themes";
import { Switch } from "@repo/ui/components/ui/switch";
import { useEffect, useState } from "react";
import { drop, parseCookies } from "@repo/ui/lib/utils";

export function ModeToggle() {
  const { setTheme, theme } = useTheme();
  const [checked, setChecked] = useState<boolean>();

  const changeTheme = (checked: boolean) => {
    const domain = drop(location.host.split(".")).join(".");
    const theme = checked ? "light" : "dark";
    document.cookie = `theme=${theme};domain=${domain};path=/`;
    setTheme(theme);
  };

  useEffect(() => {
    const currentTheme = parseCookies().theme || "dark";
    setChecked(currentTheme === "light");
    setTheme(currentTheme);
  }, [setTheme, setChecked, theme]);

  return (
    <Switch
      aria-label="toggle theme"
      uncheckedIcon="Moon"
      checkedIcon="Sun"
      checked={checked}
      onCheckedChange={changeTheme}
    ></Switch>
  );
}
